import { InjectionToken } from '@angular/core';

import { environment } from 'src/environments/environment';

import { ResolveAuthenticatedExternalLinkUrl } from './resolvers/authenticated-external-link-url.resolvers';

export const AUTHENTICATED_EXTERNAL_LINK_ROUTE_IDS = {
  marketingSolutions: 'marketing-solutions',
  portalOperations: 'portal-operations'
} as const;

export interface AuthenticatedExternalLinkRoute {
  id: string;
  domains: readonly string[];
  urlEndpoint: string;
  /** Builds the final URL from the API response and the clicked link. */
  resolveUrl: ResolveAuthenticatedExternalLinkUrl;
}

export interface AuthenticatedExternalLinkOptions {
  routes?: AuthenticatedExternalLinkRoute[];
}

export interface AuthenticatedExternalLinkConfig {
  routes: readonly AuthenticatedExternalLinkRoute[];
}

export const AUTHENTICATED_EXTERNAL_LINK_CONFIG =
  new InjectionToken<AuthenticatedExternalLinkConfig>(
    'AUTHENTICATED_EXTERNAL_LINK_CONFIG',
    {
      providedIn: 'root',
      factory: () => ({ routes: [] })
    }
  );

export function resolveMarketingSolutionsBaseUrl(
  domain = environment.domain
): string {
  const hostname = new URL(domain).hostname;
  const marketingHostname = hostname
    .replace(/^dev\.portal\./, 'dev.solucoesmarketing.')
    .replace(/^stg\.portal\./, 'stg.solucoesmarketing.')
    .replace(/^portal\./, 'solucoesmarketing.');

  return `https://${marketingHostname}/`;
}

export function resolvePortalOperationsBaseUrl(
  domain = environment.domain
): string {
  const hostname = new URL(domain).hostname;
  const portalOpsHostname = hostname
    .replace(/^dev\.portal\./, 'dev.portalops.')
    .replace(/^stg\.portal\./, 'stg.portalops.')
    .replace(/^portal\./, 'portalops.');

  return `https://${portalOpsHostname}/`;
}
